<template>
  <v-layout row wrap class="social-data-native-page" style="min-height:100vh;">
    <v-flex xs12 sm4 md3 lg2 class="navigation-flex">
      <nav class="sticky-nav-report">
        <div class="nav-header">Contents:</div>
        <a href="#hd1"><div class="contents-items-sticky">Product Overview</div></a>
        <a href="#hd2"><div class="contents-items-sticky">Value Of Social For AI</div></a>
        <a href="#hd3"><div class="contents-items-sticky">Deliverables</div></a>
        <a href="#hd4"><div class="contents-items-sticky">Data Samples</div></a>
        <a href="#hd5" class="sub-item"><div class="contents-items-sticky">Instagram</div></a>
        <a href="#hd6" class="sub-sub-item"><div class="contents-items-sticky">Basic</div></a>
        <a href="#hd7" class="sub-sub-item"><div class="contents-items-sticky">Enhanced</div></a>
        <a href="#hd8" class="sub-item"><div class="contents-items-sticky">TikTok</div></a>
        <a href="#hd9" class="sub-sub-item"><div class="contents-items-sticky">Basic</div></a>
        <a href="#hd10" class="sub-sub-item"><div class="contents-items-sticky">Enhanced</div></a>
        <a href="#hd11" class="sub-item"><div class="contents-items-sticky">X (Twitter)</div></a>
        <a href="#hd12" class="sub-sub-item"><div class="contents-items-sticky">Basic</div></a>
        <a href="#hd13" class="sub-sub-item"><div class="contents-items-sticky">Enhanced</div></a>
        <a href="#hd14" class="sub-item"><div class="contents-items-sticky">Reddit</div></a>
        <a href="#hd15" class="sub-sub-item"><div class="contents-items-sticky">Basic</div></a>
        <a href="#hd16" class="sub-sub-item"><div class="contents-items-sticky">Enhanced</div></a>
        <a href="#hd17"><div class="contents-items-sticky">Terms</div></a>
      </nav>
    </v-flex>

    <v-flex xs12 sm8 md9 lg10 class="content-flex">
      <div class="report-page-header">
        <div class="report-title-section">
          <p class="new-report-title" >Large Scale Social Media Dataset</p>
          <p class="report-subtitle">Essential Ingredient For AI Training & Tuning</p>
        </div><br>
      </div>
      
      <div class="report-main-content-card">
        <div class="report-content-body"> 
          <hr class="solid"><div style="line-height:17px;"><br></div>
          
          <div>
            <div id="hd1" style="line-height:28px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><a href="#" class="header-1"><b>Product Overview</b></a></div>
            <div style="line-height:4px;"><br></div>
            <div style="line-height:18px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black">This is a unique offering of a <b>large-scale collection of social media posts</b> from <b>Instagram, Twitter (X), Reddit, and TikTok</b> spanning a period from 2016 to 2025, offered by the leading social analytics provider Social Standards.</span></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black">Social Standards (https://www.socialstandards.com/) has been serving the <b>social analytics</b> market since early 2016. Our customers include many Fortune 500 companies (Estee Lauder, Bank of America, Coca-Cola, BCG, Diageo, etc.) that rely on our insights for their strategic decisions.</span></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black">As part of our modeling requirements, we have collected massive amounts of data (50-95% sampling rate) from 4 major social networks. This data collection has required a <b>multimillion-dollar investment</b> over the years, and this is the first time it has been made available for commercial use, adapted and restructured specifically for <b>LLM training.</b></span></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black">The offered data consists exclusively of <b>publicly available posts</b>. To protect user privacy as well as to eliminate any potential <b>privacy violation concerns</b> on the part of the LLM-training party, all user handles are unidirectionally <b>hashed</b> (makes any reconstruction of the original handles practically impossible), thus fully obfuscating user identities.</span></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black"><b>All world languages</b> are covered in the ratios native to the original web sources.</span></div>
            <div style="line-height:18px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black">The following table provides high level size and volume parameters of the offering:</span></div>
            <div style="line-height:9px;"><br></div>
            <div class="w3-container ss_block data-table-container">
              <table class="data-table">
                <thead>
                  <tr>
                    <th>Metric</th>
                    <th>Instagram</th>
                    <th>Twitter (X)</th>
                    <th>Reddit</th>
                    <th>TikTok</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>years covered</td>
                    <td>2016-2025</td>
                    <td>2016-2025</td>
                    <td>2019-2025</td>
                    <td>2019-2025</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>number of months covered</td>
                    <td>108</td>
                    <td>108</td>
                    <td>70</td>
                    <td>70</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>number of posts in billions</td>
                    <td>14.7</td>
                    <td>23.3</td>
                    <td>13.5</td>
                    <td>10.3</td>
                    <td>61.8</td>
                  </tr>
                  <tr>
                    <td>number of tokens in billions</td>
                    <td>2220</td>
                    <td>889</td>
                    <td>594</td>
                    <td>364</td>
                    <td>4067</td>
                  </tr>
                  <tr>
                    <td>appx. source coverage</td>
                    <td>80%</td>
                    <td>60%</td>
                    <td>90%</td>
                    <td>85%</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>deliverable size - basic - Tb</td>
                    <td>4.2</td>
                    <td>3</td>
                    <td>2</td>
                    <td>1.1</td>
                    <td>10.3</td>
                  </tr>
                  <tr>
                    <td>deliverable size - enhanced - Tb</td>
                    <td>8.4</td>
                    <td>6</td>
                    <td>4</td>
                    <td>2.2</td>
                    <td>20.6</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div style="line-height:9px;"><br></div>
            <div style="line-height:18px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black">Our unique training dataset product offers the most <b>cost-effective</b> solution as it is priced on a <b>cost-plus</b> basis with a marginal markup. This is made possible thanks to our pricing structure that is reflective of the original <b>costs of data gathering</b> as well as the proprietary <b>descriptive enchantments</b> we have made to that data. The underlying data does not have any value attributed to it and does not contribute to the cost. What we sell is the <b>data processing</b> and <b>data access</b> service. In other words, anybody attempting to gather the same amount of data will likely incur much larger costs as our collection process has years of optimization built-in.</span></div>

            <div id="hd2" style="line-height:28px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><a href="#" class="header-1"><b>Value Of Social For AI</b></a></div>
            <div style="line-height:4px;"><br></div>
            <div style="line-height:18px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black">Why is social data <b>critical</b> for proper LLM training setup? While traditional training sources of public domain books, mass media publications, web site contents, etc.  provide input sufficient for the core linguistic structure and codified cultural and some specialty knowledge, the <b>conversational</b> aspect of any language (especially modern forms of expression found on social media) is simply not present in these readily accessible sources to the sufficient extent.</span></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black">The choice, or preference, for training set ultimately comes down to the <b>intended use</b> of a given LLM. If the business objective is to automate customer support functions, the recordings of such support sessions must be part of the training. While today most <b>commercial applications</b> of AI (and their underlying LLMs) call for various forms of <b>specialized knowledge</b> and the records of the related communications, there is a large, and arguably most practically useful, area for future commercial application of AI: general <b>consumer intelligence</b>.</span></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black">Modern economy is a <b>consumer-driven</b> economy. Therefore, any practical ability to serve the needs of the businesses engaged in such economic activities would be predicated on LLM's ability to know and to model <b>consumer mind</b>, or more precisely, <b>minds</b> as there are numerous socially and geographically diverse groups of the consumers whose take on the wide range of topics differ greatly and whose identities cannot and should not be confused.</span></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black">Training dataset from Social Standards offers <b>breadth and depth</b> sufficient for a detailed and dynamic (up to the monthly resolution) modeling of <b>consumer mindset</b> and its linguistic patterns. Not only this set could enable an LLM that is representative of the <b>consumer market perception</b> suitable for commercial use, but also accurately model <b>individual consumer voices</b> (e.g. active-lifestyle Hispanic US resident in his/her 30s with interest in skincare).</span></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black">As we know from our own analytical application of social media data, consumer perceptions tend to be <b>much more dynamic</b> than the general societal trends as reflected in mass media or via other established channels. Currently, social media remains the one and only source capable of capturing everchanging image of the modern consumer complete with their preferences, judgements, values, and expectations.</span></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black">That is why any future AI (LLM) that aspires to speak <b>in the voice of the consumer</b> and to fairly represent <b>general public</b> for any form of generative intelligence would necessarily have to utilize large training sets based on social media or some alternative sources of general conversational data of comparable magnitude.</span></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black">Today we offer such a dataset – ready for <b>immediate use</b>.</span></div>
            <div style="line-height:18px;"><br></div>
            
            <div id="hd3" style="line-height:28px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><a href="#" class="header-1"><b>Deliverables</b></a></div>
            <div style="line-height:4px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black">Dataset is available in two trim levels:</span></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black"><ul style="width:100%; list-style-type: disc; padding-left: 20px;"><li><b>Basic</b> – post data adapted for LLM training needs sufficient for accurate representation and modeling of various forms of modern social expression. </li><li><b>Enhanced</b> – suitable for socio-economic profiling of various user cohorts (demographic, geographic, interests, etc.) and various post types (e.g. commercial/non-commercial)</li></ul></span></div>
            <div style="line-height:18px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black">The following is the data-field enumeration of the main data file (posts) for both product options:</span></div>
            <div style="line-height:9px;"><br></div>
            <div class="w3-container ss_block data-table-container">
              <table class="data-table">
                <thead>
                  <tr>
                    <th>field name</th>
                    <th>data type</th>
                    <th>basic option</th>
                    <th>Instagram enhanced</th>
                    <th>Twitter (X) enhanced</th>
                    <th>Reddit enhanced</th>
                    <th>TikTok enhanced</th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td>source</td><td>integer</td><td>X</td><td>X</td><td>X</td><td>X</td><td>X</td></tr>
                  <tr><td>month_index</td><td>integer</td><td>X</td><td>X</td><td>X</td><td>X</td><td>X</td></tr>
                  <tr><td>post_id_hash</td><td>varchar</td><td>X</td><td>X</td><td>X</td><td>X</td><td>X</td></tr>
                  <tr><td>post date</td><td>timestamp</td><td>X</td><td>X</td><td>X</td><td>X</td><td>X</td></tr>
                  <tr><td>userid_hash</td><td>varchar</td><td>X</td><td>X</td><td>X</td><td>X</td><td>X</td></tr>
                  <tr><td>post text</td><td>varchar</td><td>X</td><td>X</td><td>X</td><td>X</td><td>X</td></tr>
                  <tr><td>script</td><td>varchar(2)</td><td>X</td><td>X</td><td>X</td><td>X</td><td>X</td></tr>
                  <tr><td>comment_count</td><td>integer</td><td>X</td><td>X</td><td>X</td><td>X</td><td>X</td></tr>
                  <tr><td>like_count</td><td>integer</td><td>X</td><td>X</td><td>X</td><td>X</td><td>X</td></tr>
                  <tr><td>is_spam</td><td>boolean</td><td></td><td>X</td><td>X</td><td>X</td><td>X</td></tr>
                  <tr><td>is_commercial</td><td>boolean</td><td>X</td><td>X</td><td>X</td><td>X</td><td>X</td></tr>
                  <tr><td>location</td><td>varchar</td><td></td><td>X</td><td>X</td><td>X</td><td>X</td></tr>
                  <tr><td>state</td><td>varchar</td><td></td><td>X</td><td>X</td><td>X</td><td>X</td></tr>
                  <tr><td>country</td><td>varchar</td><td></td><td>X</td><td>X</td><td>X</td><td>X</td></tr>
                  <tr><td>main_domain_id</td><td>integer</td><td></td><td>X</td><td>X</td><td>X</td><td>X</td></tr>
                  <tr><td>domains</td><td>varchar</td><td></td><td>X</td><td>X</td><td>X</td><td>X</td></tr>
                  <tr><td>objects</td><td>varchar</td><td></td><td>X</td><td>X</td><td>X</td><td>X</td></tr>
                  <tr><td>play_count</td><td>integer</td><td></td><td></td><td></td><td></td><td>X</td></tr>
                  <tr><td>share_count</td><td>integer</td><td></td><td></td><td></td><td></td><td>X</td></tr>
                  <tr><td>subreddit name</td><td>varchar</td><td></td><td></td><td></td><td>X</td><td></td></tr>
                  <tr><td>post_type</td><td>varchar</td><td></td><td></td><td></td><td>X</td><td></td></tr>
                  <tr><td>post_flair</td><td>varchar</td><td></td><td></td><td></td><td>X</td><td></td></tr>
                  <tr><td>post_title</td><td>varchar</td><td></td><td></td><td></td><td>X</td><td></td></tr>
                  <tr><td>main post date</td><td>timestamp</td><td></td><td></td><td></td><td>X</td><td></td></tr>
                  <tr><td>main post id hash</td><td>varchar</td><td></td><td></td><td></td><td>X</td><td></td></tr>
                  <tr><td>parent_post_id_hash</td><td>varchar</td><td></td><td></td><td></td><td>X</td><td></td></tr>
                  <tr><td>cross_post_id_hash</td><td>varchar</td><td></td><td></td><td></td><td>X</td><td></td></tr>
                  <tr><td>user_demographics</td><td>varchar</td><td></td><td>X</td><td>X</td><td>X</td><td>X</td></tr>
                  <tr><td>user_interests</td><td>varchar</td><td></td><td>X</td><td>X</td><td>X</td><td>X</td></tr>
                  <tr><td>user_affinities</td><td>varchar</td><td></td><td>X</td><td>X</td><td>X</td><td>X</td></tr>
                </tbody>
              </table>
            </div>
            <div style="line-height:9px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black">The following are the descriptions of the data fields enumerated above:</span></div>
            <div style="line-height:9px;"><br></div>
            <div class="w3-container ss_block data-table-container">
              <table class="data-table field-description-table">
                <thead>
                  <tr>
                    <th>field name</th>
                    <th>description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td>source</td><td>numeric code for data source (1-Instagram, 3-Twitter, 5-Reddit, 7-TikTok)</td></tr>
                  <tr><td>month_index</td><td>number of months since 1/1/2010</td></tr>
                  <tr><td>post_id_hash</td><td>original post ID hashed</td></tr>
                  <tr><td>post date</td><td>date of posting</td></tr>
                  <tr><td>userid_hash</td><td>user handle hashed with no option for the original handle reconstruction</td></tr>
                  <tr><td>post text</td><td>full text of the original post</td></tr>
                  <tr><td>script</td><td>2 character ISO 639-1 language code - for primary language of the post</td></tr>
                  <tr><td>comment_count</td><td>number of comments</td></tr>
                  <tr><td>like_count</td><td>number of likes</td></tr>
                  <tr><td>is_spam</td><td>flag indicating the agiven post is classified as Spam</td></tr>
                  <tr><td>is_commercial</td><td>flag indicating the agiven post is classified as Commrcial</td></tr>
                  <tr><td>location</td><td>posting location</td></tr>
                  <tr><td>state</td><td>state portion of posting location</td></tr>
                  <tr><td>country</td><td>country portion of posting location</td></tr>
                  <tr><td>main_domain_id</td><td>numeric domain ID for the domain most relevant for a given post</td></tr>
                  <tr><td>domains</td><td>numeric domain IDs separated by '~'</td></tr>
                  <tr><td>objects</td><td>list of Social Statndards objects relevant for post separated by '~'</td></tr>
                  <tr><td>play_count</td><td>TikTok only: number of plays</td></tr>
                  <tr><td>share_count</td><td>TikTok only: number of shares</td></tr>
                  <tr><td>subreddit name</td><td>Reddit only: name of the subreddit</td></tr>
                  <tr><td>post_type</td><td>Reddit only: type of post: main or comment</td></tr>
                  <tr><td>post_flair</td><td>Reddit only: flair of the post</td></tr>
                  <tr><td>post_title</td><td>Reddit only: title of Reddit post</td></tr>
                  <tr><td>main post date</td><td>Reddit only: date of the main post</td></tr>
                  <tr><td>main post id hash</td><td>Reddit only: ID of the original main post hashed</td></tr>
                  <tr><td>parent_post_id_hash</td><td>Reddit only: ID of the original parent post hashed</td></tr>
                  <tr><td>cross_post_id_hash</td><td>Reddit only: ID of the original cross post hashed</td></tr>
                  <tr><td>user_demographics</td><td>numeric user descriptor IDs separated by '~'</td></tr>
                  <tr><td>user_interests</td><td>numeric user descriptor IDs separated by '~'</td></tr>
                  <tr><td>user_affinities</td><td>numeric user descriptor IDs separated by '~'</td></tr>
                </tbody>
              </table>
            </div>
            <div style="line-height:9px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black">In addition to the main data file two reference files are also provided</span></div>
            <div style="line-height:9px;"><br></div>
            <div class="w3-container ss_block data-table-container">
              <table class="data-table domain-reference-table">
                <thead>
                  <tr>
                    <th>field name</th>
                    <th>description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td>domain_id</td><td>unique numeric identifier</td></tr>
                  <tr><td>domain_name</td><td>name of the market vertical (domain)</td></tr>
                </tbody>
              </table>
            </div>
            <div style="line-height:9px;"><br></div>
            <div style="line-height:9px;"><br></div>
            <div class="w3-container ss_block data-table-container">
              <table class="data-table user-descriptor-table">
                <thead>
                  <tr>
                    <th>field name</th>
                    <th>description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td>descriptor_id</td><td>unique numeric identifier</td></tr>
                  <tr><td>descriptor_name</td><td>name of the descriptor</td></tr>
                </tbody>
              </table>
            </div>
            <div style="line-height:9px;"><br></div>
            <div style="line-height:18px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black">Data is available in the form of <b>digital transfer</b> from AWS S3 location via secure link.</span></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black">Data exports are encoded in <b>UTF8</b> and are structured in the <b>database-import-ready</b> form. Data is available in the industry standard formats of <b>CSV, JSON-LD, Parquet.</b></span></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black">Output consists of a collection of chronological files with the following naming convention:  [data source]_[trim level]_[month index]_[sequence].gzip, where <b>data source</b> is one of IG, TW, RD, TT; <b>trim level</b> is either B (Basic) or E (enhanced); <b>month index</b> is the number of months of the file's month from 1/1/2010; and <b>sequence</b> is the incremental number of the file within a given month.</span></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black">Custom data export options can also be made available for a nominal NRE fee.</span></div>
            <div style="line-height:18px;"><br></div>

            <div id="hd4" style="line-height:28px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><a href="#" class="header-1"><b>Data Samples</b></a></div>
            <div style="line-height:4px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black"><b>Data Sample</b> links are below:</span></div>
            
            <div id="hd5" style="line-height:14px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><a href="#" class="header-2"><b>Instagram</b></a></div>
            <div style="line-height:4px;"><br></div>
            <div id="hd6" style="line-height:14px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><a href="#" class="header-3"><b>Basic</b></a></div>
            <div style="line-height:4px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;">&nbsp; &nbsp; &nbsp; <span style="font-size:14px;"><a href="https://ss-post-export.s3.us-west-2.amazonaws.com/post/sample/source_1/month_2024_03/csv/1_B_171_000.csv.gz" target="_blank" rel="noopener noreferrer"> Sample - CSV</a></span> &nbsp; &nbsp; &nbsp;</div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;">&nbsp; &nbsp; &nbsp; <span style="font-size:14px;"><a href="https://ss-post-export.s3.us-west-2.amazonaws.com/post/sample/source_1/month_2024_03/ldjson/1_B_171_000.ldjson.gz" target="_blank" rel="noopener noreferrer"> Sample - JSON LD</a></span> &nbsp; &nbsp; &nbsp;</div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;">&nbsp; &nbsp; &nbsp; <span style="font-size:14px;"><a href="https://ss-post-export.s3.us-west-2.amazonaws.com/post/sample/source_1/month_2024_03/parquet/1_B_171_000.parquet" target="_blank" rel="noopener noreferrer"> Sample - Parquet</a></span> &nbsp; &nbsp; &nbsp;</div>
            <div id="hd7" style="line-height:14px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><a href="#" class="header-3"><b>Enhanced</b></a></div>
            <div style="line-height:4px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;">&nbsp; &nbsp; &nbsp; <span style="font-size:14px;"><a href="https://ss-post-export.s3.us-west-2.amazonaws.com/post/sample_enhanced/source_1/month_2024_02/csv/1_E_170_000.csv.gz" target="_blank" rel="noopener noreferrer"> Sample - CSV</a></span> &nbsp; &nbsp; &nbsp;</div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;">&nbsp; &nbsp; &nbsp; <span style="font-size:14px;"><a href="https://ss-post-export.s3.us-west-2.amazonaws.com/post/sample_enhanced/source_1/month_2024_02/ldjson/1_E_170_000.ldjson.gz" target="_blank" rel="noopener noreferrer"> Sample - JSON LD</a></span> &nbsp; &nbsp; &nbsp;</div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;">&nbsp; &nbsp; &nbsp; <span style="font-size:14px;"><a href="https://ss-post-export.s3.us-west-2.amazonaws.com/post/sample_enhanced/source_1/month_2024_02/parquet/1_E_170_000.parquet" target="_blank" rel="noopener noreferrer"> Sample - Parquet</a></span> &nbsp; &nbsp; &nbsp;</div>
            
            <div id="hd8" style="line-height:14px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><a href="#" class="header-2"><b>TikTok</b></a></div>
            <div style="line-height:4px;"><br></div>
            <div id="hd9" style="line-height:14px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><a href="#" class="header-3"><b>Basic</b></a></div>
            <div style="line-height:4px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;">&nbsp; &nbsp; &nbsp; <span style="font-size:14px;"><a href="https://ss-post-export.s3.us-west-2.amazonaws.com/post/sample/source_7/month_2024_03/csv/7_B_171_000.csv.gz" target="_blank" rel="noopener noreferrer"> Sample - CSV</a></span> &nbsp; &nbsp; &nbsp;</div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;">&nbsp; &nbsp; &nbsp; <span style="font-size:14px;"><a href="https://ss-post-export.s3.us-west-2.amazonaws.com/post/sample/source_7/month_2024_03/ldjson/7_B_171_000.ldjson.gz" target="_blank" rel="noopener noreferrer"> Sample - JSON LD</a></span> &nbsp; &nbsp; &nbsp;</div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;">&nbsp; &nbsp; &nbsp; <span style="font-size:14px;"><a href="https://ss-post-export.s3.us-west-2.amazonaws.com/post/sample/source_7/month_2024_03/parquet/7_B_171_000.parquet" target="_blank" rel="noopener noreferrer"> Sample - Parquet</a></span> &nbsp; &nbsp; &nbsp;</div>
            <div id="hd10" style="line-height:14px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><a href="#" class="header-3"><b>Enhanced</b></a></div>
            <div style="line-height:4px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;">&nbsp; &nbsp; &nbsp; <span style="font-size:14px;"><a href="https://ss-post-export.s3.us-west-2.amazonaws.com/post/sample_enhanced/source_7/month_2024_02/csv/7_E_170_000.csv.gz" target="_blank" rel="noopener noreferrer"> Sample - CSV</a></span> &nbsp; &nbsp; &nbsp;</div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;">&nbsp; &nbsp; &nbsp; <span style="font-size:14px;"><a href="https://ss-post-export.s3.us-west-2.amazonaws.com/post/sample_enhanced/source_7/month_2024_02/ldjson/7_E_170_000.ldjson.gz" target="_blank" rel="noopener noreferrer"> Sample - JSON LD</a></span> &nbsp; &nbsp; &nbsp;</div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;">&nbsp; &nbsp; &nbsp; <span style="font-size:14px;"><a href="https://ss-post-export.s3.us-west-2.amazonaws.com/post/sample_enhanced/source_7/month_2024_02/parquet/7_E_170_000.parquet" target="_blank" rel="noopener noreferrer"> Sample - Parquet</a></span> &nbsp; &nbsp; &nbsp;</div>

            <div id="hd11" style="line-height:14px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><a href="#" class="header-2"><b>X (Twitter)</b></a></div>
            <div style="line-height:4px;"><br></div>
            <div id="hd12" style="line-height:14px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><a href="#" class="header-3"><b>Basic</b></a></div>
            <div style="line-height:4px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;">&nbsp; &nbsp; &nbsp; <span style="font-size:14px;"><a href="https://ss-post-export.s3.us-west-2.amazonaws.com/post/sample/source_3/month_2024_03/csv/3_B_171_000.csv.gz" target="_blank" rel="noopener noreferrer"> Sample - CSV</a></span> &nbsp; &nbsp; &nbsp;</div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;">&nbsp; &nbsp; &nbsp; <span style="font-size:14px;"><a href="https://ss-post-export.s3.us-west-2.amazonaws.com/post/sample/source_3/month_2024_03/ldjson/3_B_171_000.ldjson.gz" target="_blank" rel="noopener noreferrer"> Sample - JSON LD</a></span> &nbsp; &nbsp; &nbsp;</div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;">&nbsp; &nbsp; &nbsp; <span style="font-size:14px;"><a href="https://ss-post-export.s3.us-west-2.amazonaws.com/post/sample/source_3/month_2024_03/parquet/3_B_171_000.parquet" target="_blank" rel="noopener noreferrer"> Sample - Parquet</a></span> &nbsp; &nbsp; &nbsp;</div>
            <div id="hd13" style="line-height:14px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><a href="#" class="header-3"><b>Enhanced</b></a></div>
            <div style="line-height:4px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;">&nbsp; &nbsp; &nbsp; <span style="font-size:14px;"><a href="https://ss-post-export.s3.us-west-2.amazonaws.com/post/sample_enhanced/source_3/month_2024_02/csv/3_E_170_000.csv.gz" target="_blank" rel="noopener noreferrer"> Sample - CSV</a></span> &nbsp; &nbsp; &nbsp;</div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;">&nbsp; &nbsp; &nbsp; <span style="font-size:14px;"><a href="https://ss-post-export.s3.us-west-2.amazonaws.com/post/sample_enhanced/source_3/month_2024_02/ldjson/3_E_170_000.ldjson.gz" target="_blank" rel="noopener noreferrer"> Sample - JSON LD</a></span> &nbsp; &nbsp; &nbsp;</div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;">&nbsp; &nbsp; &nbsp; <span style="font-size:14px;"><a href="https://ss-post-export.s3.us-west-2.amazonaws.com/post/sample_enhanced/source_3/month_2024_02/parquet/3_E_170_000.parquet" target="_blank" rel="noopener noreferrer"> Sample - Parquet</a></span> &nbsp; &nbsp; &nbsp;</div>

            <div id="hd14" style="line-height:14px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><a href="#" class="header-2"><b>Reddit</b></a></div>
            <div style="line-height:4px;"><br></div>
            <div id="hd15" style="line-height:14px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><a href="#" class="header-3"><b>Basic</b></a></div>
            <div style="line-height:4px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;">&nbsp; &nbsp; &nbsp; <span style="font-size:14px;"><a href="https://ss-post-export.s3.us-west-2.amazonaws.com/post/sample/source_5/month_2024_03/csv/5_B_171_000.csv.gz" target="_blank" rel="noopener noreferrer"> Sample - CSV</a></span> &nbsp; &nbsp; &nbsp;</div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;">&nbsp; &nbsp; &nbsp; <span style="font-size:14px;"><a href="https://ss-post-export.s3.us-west-2.amazonaws.com/post/sample/source_5/month_2024_03/ldjson/5_B_171_000.ldjson.gz" target="_blank" rel="noopener noreferrer"> Sample - JSON LD</a></span> &nbsp; &nbsp; &nbsp;</div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;">&nbsp; &nbsp; &nbsp; <span style="font-size:14px;"><a href="https://ss-post-export.s3.us-west-2.amazonaws.com/post/sample/source_5/month_2024_03/parquet/5_B_171_000.parquet" target="_blank" rel="noopener noreferrer"> Sample - Parquet</a></span> &nbsp; &nbsp; &nbsp;</div>
            <div id="hd16" style="line-height:14px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><a href="#" class="header-3"><b>Enhanced</b></a></div>
            <div style="line-height:4px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;">&nbsp; &nbsp; &nbsp; <span style="font-size:14px;"><a href="https://ss-post-export.s3.us-west-2.amazonaws.com/post/sample_enhanced/source_5/month_2024_02/csv/5_E_170_000.csv.gz" target="_blank" rel="noopener noreferrer"> Sample - CSV</a></span> &nbsp; &nbsp; &nbsp;</div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;">&nbsp; &nbsp; &nbsp; <span style="font-size:14px;"><a href="https://ss-post-export.s3.us-west-2.amazonaws.com/post/sample_enhanced/source_5/month_2024_02/ldjson/5_E_170_000.ldjson.gz" target="_blank" rel="noopener noreferrer"> Sample - JSON LD</a></span> &nbsp; &nbsp; &nbsp;</div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;">&nbsp; &nbsp; &nbsp; <span style="font-size:14px;"><a href="https://ss-post-export.s3.us-west-2.amazonaws.com/post/sample_enhanced/source_5/month_2024_02/parquet/5_E_170_000.parquet" target="_blank" rel="noopener noreferrer"> Sample - Parquet</a></span> &nbsp; &nbsp; &nbsp;</div>
            <div style="line-height:18px;"><br></div>
            
            <div id="hd17" style="line-height:28px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><a href="#" class="header-1"><b>Terms</b></a></div>
            <div style="line-height:4px;"><br></div>
            <div style="line-height:18px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black">The data offering is structured as a grant of data access rights - as a license for specific use.</span></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black">The terms of the data access agreement prescribe intended use of the delivered data as exclusive for LLM training purposes. It is not limited in terms of number of trainings or periods of time. For the avoidance of doubt, any other use of the licensed dataset is not permitted, including sharing with a third party, resale, or any other form of data dissemination.</span></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black">Pricing is based on a <b>cost-plus</b> model, with the product is offered as a full set of all four social media sources, or on a source-by-source basis.</span></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em;"><span style="font-size:14px;color:black">Exact pricing available upon request, pending qualification.</span></div>
            <div style="line-height:18px;"><br></div>
            <div style="line-height:18px;"><br></div>
            <div class="w3-container ss_block" style="padding:0.2em;font-size:1em; text-align: center;"><span style="font-size:14px;color:black"><i>Interested parties, please reach out to </i>  <a href="mailto:contact@socialstandards.com" target="_top"> contact@socialstandards.com </a></span></div>
            <div style="line-height:18px;"><br></div>
            <div style="line-height:18px;"><br></div>
            <div style="line-height:18px;"><br></div>

            <div>
              <div style="line-height:0.9em;"><br></div>
              <div class="w3-container" style="font-size:10px;color:silver;text-align: center">
                2015-2025 © by Social Standards, Inc.
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 
                last updated on May 16, 2025<br>&nbsp;
              </div>
              <div style="line-height:0.5em;"><br></div>
            </div>

          </div>
        </div> 
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'SocialDataNativePage',
  mounted() {
    // Implement smooth scrolling for anchor links if not handled by browser/Vue Router
    document.querySelectorAll('.sticky-nav-report a[href^="#"], .report-main-content-card a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        const hrefAttribute = this.getAttribute('href');
        // Ensure it's a valid ID selector and not just "#"
        if (hrefAttribute && hrefAttribute.length > 1 && hrefAttribute.startsWith('#')) {
          const targetElement = document.getElementById(hrefAttribute.substring(1));
          if (targetElement) {
            e.preventDefault();
            targetElement.scrollIntoView({
              behavior: 'smooth'
            });
          }
        } else if (hrefAttribute === "#") {
            e.preventDefault(); // Prevent jumping to top for href="#"
        }
      });
    });
  }
};
</script>

<style scoped>
.social-data-native-page {
  /* Using v-layout, so some global styles from App.vue might apply */
}

.navigation-flex {
  background-color: #131737; /* Dark blue from AdminView */
  height: 100vh; /* Full height */
  position: sticky; /* Keep it sticky if layout scrolls */
  top: 0;
}

.sticky-nav-report {
  width: 100%; 
  height: 100%; 
  color: white;
  padding: 1.5em; 
  overflow-y: auto;
  font-family: "Roboto-Regular", "Sans-Serif", "Arial"; 
}

.sticky-nav-report .nav-header {
  font-size: 1.2em; 
  font-weight: 500; 
  color: #FFFFFF;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #4A4F6C; 
}

.sticky-nav-report a {
  text-decoration: none;
  color: #B0BEC5; 
  display: block; 
  margin-bottom: 2px; 
}
.sticky-nav-report a:hover {
  color: #FFFFFF;
  background-color: #2C304F; 
}

.contents-items-sticky {
  padding: 8px 10px; 
  font-size: 0.95em; 
}

.sticky-nav-report a.sub-item > .contents-items-sticky {
  padding-left: 25px; 
  font-size: 0.9em;
}

.sticky-nav-report a.sub-sub-item > .contents-items-sticky {
  padding-left: 40px; 
  font-size: 0.85em;
}

/* Main content area */
.content-flex {
  padding: 2em; 
  background-color: #131737; /* UPDATED: Dark blue background for the entire content column */
}

/* NEW: Styles for the dark blue header block */
.report-page-header {
  background-color: #131737;
  padding: 1em;
  margin-bottom: 1.5em; /* Space between this header and the white card below */
  max-width: 888px; /* Match the card width */
  margin-left: auto;
  margin-right: auto;
  border-radius: 4px; /* Optional: slight rounding if desired */
  text-align: center; /* Center the title block */
}

.report-main-content-card {
  max-width: 888px; 
  margin-left: auto; /* Center the card if content-flex is wider */
  margin-right: auto;
  background-color: #FFFFFF; 
  padding: 2em;
  box-shadow: 0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12); 
}

.report-content-body {
  font-family: 'Roboto', sans-serif;
  color: #333;
}

/* Styles from reportWikiStyle.css that might be useful, adapted for Vuetify context */
.header-1, .header-2, .header-3 {
  font-family: 'Roboto', sans-serif; /* Use a consistent font */
  color: #131737; /* Dark blue, similar to AdminView tabs */
  font-weight: 500; /* Medium weight for headers */
  cursor: pointer;
  text-decoration: none;
}
.header-1:hover, .header-2:hover, .header-3:hover {
  text-decoration: underline;
}

.header-1 b, .header-2 b, .header-3 b {
  font-weight: 500; /* Override internal bolds if needed or ensure consistency */
}
.header-1 {
  font-size: 1.5em; /* Larger for main section titles */
  margin-top: 1.5em; 
  margin-bottom: 0.8em;
}
.header-2 {
  font-size: 1.3em;
  margin-top: 1.2em;
  margin-bottom: 0.6em;
}
.header-3 {
  font-size: 1.1em;
  margin-top: 1em;
  margin-bottom: 0.5em;
}

.ss_block {
  margin-bottom: 15px; 
}

/* Copied from previous version, might need adjustments */
.report-title-section .new-report-title {
  font-size: 2.0em; 
  color: #FFF; 
  font-weight:700;
  margin-bottom: 0.2em;
  margin-top: 0.5em;
}

.report-title-section .report-subtitle {
  font-size: 1.2em;  
  color: #BBB; 
  margin-top: 0;
}

.de-coded {
  font-size: 1em;
  color: white;
}
.ss_orange {
  color: #f5a941; /* $orange from App.vue */
}

.w3-container span[style*="font-size:14px"] {
  font-size: 14px;
  line-height: 1.6;
  color: #333333; /* Ensure readability */
}
.w3-container b {
  font-weight: bold; 
}

ul[style*="list-style-type: disc"] {
  list-style-type: disc;
  padding-left: 40px; 
  font-size: 14px; /* Match span text */
  color: #333333;
}
ul li {
    margin-bottom: 5px;
}

hr.solid {
 border-top: 1px solid #CFD8DC; /* Vuetify-like divider color */
 margin-top: 20px;
 margin-bottom: 20px;
}

.report-content-body img {
  max-width: 100%; 
  height: auto;
  display: block; 
  margin: 20px auto; /* Center images with margin */
  border: 1px solid #EEE; /* Subtle border */
  border-radius: 4px;
}

/* NEW: Styles for the HTML data table */
.data-table-container {
  overflow-x: auto; /* Add scroll for smaller screens if table is too wide */
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  margin: 1em 0;
  font-size: 13px; /* Slightly smaller font for table data */
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
}

.data-table th,
.data-table td {
  border: 1px solid #ddd; /* Light grey border for cells */
  padding: 10px 12px; /* More padding */
  text-align: left;
  line-height: 1.4;
}

.data-table thead tr {
  background-color: #E3F2FD; /* Light blue background for header row - Vuetify-like */
  color: #131737; /* Dark blue text for header */
  font-weight: 500;
}

.data-table tbody tr:nth-child(even) {
  background-color: #f9f9f9; /* Zebra striping for even rows */
}

.data-table tbody tr:hover {
  background-color: #f1f1f1; /* Hover effect for rows */
}

.data-table td:nth-child(1) { /* First column (Metric names) */
  font-weight: 500;
  color: #263238; /* Slightly darker text for metric names */
}

.field-description-table td:nth-child(2) {
  /* Potentially make the description column wider or allow more flexible wrapping if needed */
  word-break: break-word; /* Helps with long descriptions */
}

.domain-reference-table td:nth-child(2) {
  word-break: break-word;
}

.user-descriptor-table td:nth-child(2) {
  word-break: break-word;
}
</style> 